import React, { useEffect } from 'react';
import { Button, Dialog, Text, Box, Flex, FilterChip, Relative } from 'pcln-design-system';
import analytics from '../analytics/analytics';
import { useChatMessagesContext } from '../hooks/useChatMessagesContext';
export const amenitiesMap = {
  HEALTHSVCS: 'Health Services',
  HANDFAC: 'Handicap-accessible Facilities',
  FAMFRIEND: 'Family Friendly',
  FPRKING: 'Free Parking',
  FINTRNT: 'Free Internet',
  NSMKFAC: 'Non-smoking Facilities',
  SPOOL: 'Swimming Pool',
  SUSTAIN: 'Sustainable Practices',
  KIDFRIEND: 'Kid Friendly',
  PETALLOW: 'Pets Allowed',
  RESTRNT: 'Restaurant',
  FBRKFST: 'Free Breakfast',
  FITSPA: 'Fitness Center',
  HOTTUB: 'Hot Tub',
  SPA: 'Spa Services',
  BUSCNTR: 'Business Center',
  SPOOLOUT: 'Outdoor Swimming Pool',
  FINTRRM: 'Free In-room Internet',
  FINTRPUB: 'Free Public Internet',
  KITCHEN: 'Kitchen Facilities',
  BCHFRNT: 'Beachfront Location',
  CASINO: 'Casino',
  FAIRSHUTTL: 'Airport Shuttle (fee)',
  AIRSHUTTL: 'Airport Shuttle',
  SPOOLIN: 'Indoor Swimming Pool',
  ADULTONLY: 'Adult Only Property',
  FINTRAVL: 'Free Internet in Common Areas',
  INCLUSIVE: 'All-Inclusive Option'
};
const formatFilterList = (filters = []) => {
  if (filters.length === 0) {
    return '';
  } else if (filters.length === 1) {
    return filters[0];
  } else {
    const lastFilter = filters.pop();
    return `${filters.join(', ')}, and ${lastFilter}`;
  }
};
export const HotelFilterComponent = props => {
  var _a, _b;
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedAmenities, setSelectedAmenities] = React.useState({});
  const [prevSelectedAmenities, setPrevSelectedAmenities] = React.useState({});
  const searchUrl = (props === null || props === void 0 ? void 0 : props.clientRedirectUrl) || '';
  const amenities = ((_a = props === null || props === void 0 ? void 0 : props.args) === null || _a === void 0 ? void 0 : _a.amenities) || '';
  const {
    chatMessages
  } = useChatMessagesContext();
  useEffect(() => {
    const prevSelected = amenities === null || amenities === void 0 ? void 0 : amenities.split(',').reduce((res, key) => {
      res[key] = true;
      return res;
    }, {});
    setSelectedAmenities(prevSelected);
    setPrevSelectedAmenities(prevSelected);
  }, amenities);
  const {
    setChatMessages,
    submitMessages,
    searchResult,
    hasSopqHotel,
    hasRtlHotel,
    toggleOnlyExpressDealClick,
    displaySopqOnly
  } = props;
  const {
    tripFilterSummary,
    totalSize
  } = searchResult;
  const hotelCount = (tripFilterSummary === null || tripFilterSummary === void 0 ? void 0 : tripFilterSummary.totalSizeFiltered) || totalSize;
  const onFilterClick = function () {
    analytics.log(Object.assign({
      label: 'HotelSearchResult',
      message: 'ALL_HOTEL_FILTERS_LINK_CLICKED'
    }, props === null || props === void 0 ? void 0 : props.args));
    setIsOpen(true);
  };
  const onAllResultsLinkClick = function () {
    analytics.log(Object.assign({
      label: 'HotelSearchResult',
      message: 'ALL_HOTEL_RESULTS_LINK_CLICKED',
      searchUrl
    }, props === null || props === void 0 ? void 0 : props.args));
    window.open(searchUrl, '_blank');
  };
  const {
    amenityCounts
  } = ((_b = props.searchResult) === null || _b === void 0 ? void 0 : _b.tripFilterSummary) || {};
  return React.createElement(Relative, {
    top: '5px'
  }, React.createElement(Flex, {
    alignItems: 'center',
    ml: 3,
    mb: 4
  }, amenityCounts ? React.createElement(Button, {
    variation: 'subtle',
    onClick: onFilterClick,
    mr: 2,
    size: 'small'
  }, "Filter Options") : null, hasSopqHotel && hasRtlHotel && React.createElement(Button, {
    variation: 'subtle',
    onClick: toggleOnlyExpressDealClick,
    mr: 2,
    size: 'small'
  }, displaySopqOnly ? 'Show Deals' : 'Show Express Deals Only'), searchUrl && hotelCount ? React.createElement(Button, {
    variation: 'subtle',
    onClick: onAllResultsLinkClick,
    size: 'small'
  }, "View ", hotelCount, " Results") : null, React.createElement(Dialog, {
    showCloseButton: true,
    scrimDismiss: false,
    open: isOpen,
    size: 'md',
    onOpenChange: function (isOpen) {
      if (!isOpen) {
        setIsOpen(false);
      }
    },
    borderRadius: 'xl',
    ariaDescription: 'Dialog to filter hotels',
    ariaTitle: 'Filter hotels',
    scrimColor: 'dark',
    headerContent: React.createElement(Text, null, "Available Hotel Filter Options")
  }, React.createElement(Box, {
    p: 4
  }, amenityCounts ? React.createElement(React.Fragment, null, Object.keys(amenityCounts).map((key, i) => {
    const counts = amenityCounts[key];
    const isSelected = Boolean(selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]);
    const name = `chip-${key}-${i}`;
    return React.createElement(FilterChip, {
      key: name,
      name: name,
      m: 1,
      selected: isSelected,
      label: `${(amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key} (${counts})`,
      showActionIcon: isSelected,
      disabled: Number(counts) === 0,
      onClick: function () {
        setSelectedAmenities(Object.assign(Object.assign({}, selectedAmenities), {
          [key]: !isSelected
        }));
      }
    });
  })) : null, React.createElement(Box, null, React.createElement("br", null), React.createElement(Button, {
    onClick: function (event) {
      event.preventDefault();
      const {
        addedFilters,
        removedFilters
      } = Object.keys(selectedAmenities).reduce((acc, key) => {
        const amenityName = (amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key;
        if (selectedAmenities[key] && !prevSelectedAmenities[key]) {
          acc.addedFilters.push(amenityName);
        }
        if (!selectedAmenities[key] && prevSelectedAmenities[key]) {
          acc.removedFilters.push(amenityName);
        }
        return acc;
      }, {
        addedFilters: [],
        removedFilters: []
      });
      // Generate the message based on added and removed filters
      let content = '';
      if (addedFilters.length > 0) {
        content += `Added the following filters: ${formatFilterList(addedFilters)}. `;
      }
      if (removedFilters.length > 0) {
        content += `Removed the following filters: ${formatFilterList(removedFilters)}.`;
      }
      const promptMessage = {
        role: 'user',
        content: content
      };
      analytics.log(Object.assign({
        label: 'HotelSearchResult',
        message: 'APPLY_HOTEL_FILTERS_CLICKED',
        addedFilterOptions: addedFilters.join(',') || 'none',
        removedFilterOptions: addedFilters.join(', ') || 'none'
      }, props === null || props === void 0 ? void 0 : props.args));
      // new message in Dialog
      const displayMessage = Object.assign(Object.assign({}, promptMessage), {
        date: new Date()
      });
      setChatMessages([...chatMessages, displayMessage]);
      submitMessages(promptMessage);
      setIsOpen(false);
    }
  }, "Apply Filters"))))));
};